var BlockQueryKeys={global:['blocks']};export{BlockQueryKeys};